export default __webpack_public_path__ + "images/384b04f25826b885bb36dbf1d2d847c1.svg";